import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
      boxShadow: '0 4px 20px rgba(124, 58, 237, 0.3)',
      zIndex: 1000
    }}>
      {/* Trust Bar */}
      <div style={{
        background: 'rgba(0,0,0,0.15)',
        padding: '0.5rem 0',
        fontSize: '0.85rem',
        color: 'rgba(255,255,255,0.95)',
        textAlign: 'center',
        borderBottom: '1px solid rgba(255,255,255,0.1)'
      }}>
        <div style={{maxWidth: '1200px', margin: '0 auto', padding: '0 2rem', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '2rem', flexWrap: 'wrap'}}>
          <span>🏢 EIN: 86-3326707</span>
          <span>✓ A2P Registered</span>
          <span>📍 Atlanta, GA</span>
          <span>📞 contact@tejsolutionshub.com</span>
        </div>
      </div>

      <div style={{maxWidth: '1200px', margin: '0 auto', padding: '1rem 2rem'}}>
        <nav style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <Link to="/" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            textDecoration: 'none',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '1.5rem',
            fontWeight: '700',
            color: '#ffffff'
          }}>
            <svg width="45" height="45" viewBox="0 0 45 45" fill="none">
              <rect width="45" height="45" rx="10" fill="rgba(255,255,255,0.25)"/>
              <path d="M15 18h15v3H15z" fill="#ffffff"/>
              <path d="M20 24h10v3H20z" fill="#fbbf24"/>
              <path d="M18 30h14v3H18z" fill="#c4b5fd"/>
              <circle cx="35" cy="35" r="6" fill="#fbbf24"/>
              <text x="35" y="38" fontSize="8" fontWeight="bold" fill="#7c3aed" textAnchor="middle">T</text>
            </svg>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
              <span style={{fontSize: '1.5rem', lineHeight: '1.2'}}>TEJ Solutions Hub</span>
              <span style={{fontSize: '0.7rem', opacity: '0.85', fontWeight: '400', letterSpacing: '0.5px'}}>TEJ SUSTAINABILITY GROUP, INC.</span>
            </div>
          </Link>
          
          <ul style={{
            display: 'flex',
            gap: '2rem',
            listStyle: 'none',
            margin: 0,
            padding: 0,
            alignItems: 'center'
          }} className="desktop-nav">
            <li><Link to="/" style={{color: location.pathname === '/' ? '#fbbf24' : 'rgba(255,255,255,0.9)', textDecoration: 'none', fontWeight: '500'}}>Home</Link></li>
            <li><Link to="/services" style={{color: location.pathname === '/services' ? '#fbbf24' : 'rgba(255,255,255,0.9)', textDecoration: 'none', fontWeight: '500'}}>Services</Link></li>
            <li><Link to="/portfolio" style={{color: location.pathname === '/portfolio' ? '#fbbf24' : 'rgba(255,255,255,0.9)', textDecoration: 'none', fontWeight: '500'}}>Portfolio</Link></li>
            <li><Link to="/pricing" style={{color: location.pathname === '/pricing' ? '#fbbf24' : 'rgba(255,255,255,0.9)', textDecoration: 'none', fontWeight: '500'}}>Pricing</Link></li>
            <li><Link to="/about-us" style={{color: location.pathname === '/about-us' ? '#fbbf24' : 'rgba(255,255,255,0.9)', textDecoration: 'none', fontWeight: '500'}}>About</Link></li>
            <li><Link to="/contact" style={{color: location.pathname === '/contact' ? '#fbbf24' : 'rgba(255,255,255,0.9)', textDecoration: 'none', fontWeight: '500'}}>Contact</Link></li>
          </ul>
          
          <Link to="/contact" style={{
            padding: '0.75rem 1.5rem',
            background: '#fbbf24',
            color: '#1f2937',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '0.95rem',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(251, 191, 36, 0.3)'
          }} className="cta-button">
            Get Started
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
